import { lazy } from 'react';
import MainLayout from 'layouts/MainLayout';

const LandingPage = lazy(() => import('../pages/LandingPage'));
const ProjectPage = lazy(() => import('../pages/ProjectPage'));
const PresentationPage = lazy(() => import('../pages/PresentationPage'));

const routes = [{
    layout: MainLayout,
    routes: [{
        path: '/agents/cashflow-forecast/:agentId',
        element: LandingPage,
        exact: true,
        analytics: { name: ["Agente", "Cashflow Forecast"] },
    }, {
        path: '/agents/cashflow-forecast/:agentId/conversations/:conversationId',
        element: ProjectPage,
        exact: true,
        analytics: { name: ["Agente", "Cashflow Forecast", "Progetto"] },
    }, {
        path: '/agents/cashflow-forecast/:agentId/conversations/:conversationId/presentation',
        element: PresentationPage,
        exact: true,
        analytics: { name: ["Agente", "Cashflow Forecast", "Presentazione"] },
    }]
}];

export default routes;
